// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1JMlK","col":"CardReaderDesc_col__3Zqe2","label":"CardReaderDesc_label__2bC3v"};